import { lazy } from 'react';

export const PlayerUpdateMarketingBlockForm = lazy(
  () => import('./PlayerUpdateMarketingBlockForm'),
);
